import { gql } from '@apollo/client';
import type { PartnerAccount, PartnerContent, PartnerDocument } from 'types/Partner';
import {PARTNER_ACCOUNT_FRAGMENT, PARTNER_CONTENT_FRAGMENT, PARTNER_DOCUMENT_FRAGMENT} from './PartnerDocumentsFragments';

export const GET_PARTNER_ACCOUNTS_WITH_FAMILY_PORTAL_QUERY = gql`
  query GetPartnerAccountsWithFamilyPortal($channel: String!) {
    getPartnerAccountsWithFamilyPortal(channel: $channel) {
      partnerAccounts {
        ...partnerAccountFields
      }
    }
  }
  ${PARTNER_ACCOUNT_FRAGMENT}
`;

export type GetPartnerAccountsWithFamilyPortalOutput = {
  getPartnerAccountsWithFamilyPortal: {
    partnerAccounts: PartnerAccount[];
  };
};

export const GET_PARTNER_DOCUMENTS_QUERY = gql`
  query GetPartnerDocuments(
    $getPartnerDocumentsInput: GetPartnerDocumentsInput!
  ) {
    getPartnerDocuments(getPartnerDocumentsInput: $getPartnerDocumentsInput) {
      documents {
        ...partnerDocumentFields
      }
    }
  }
  ${PARTNER_DOCUMENT_FRAGMENT}
`;

export enum GetPartnerDocumentsError {
  NOT_CONNECTED_TO_PARTNER = 'NOT_CONNECTED_TO_PARTNER',
  NO_FAMILY_PORTAL = 'NO_FAMILY_PORTAL',
  PARTNER_NOT_FOUND = 'PARTNER_NOT_FOUND',
  UNAUTHORIZED = 'UNAUTHORIZED',
  UNKNOWN_ERROR = 'UNKNOWN_ERROR',
}

export type GetPartnerDocumentsOutput = {
  getPartnerDocuments: {
    documents: PartnerDocument[];
    errorReason: GetPartnerDocumentsError[];
  };
};

export const GET_PARTNER_BOOKMARKS_QUERY = gql`
  query GetPartnerBookmarks(
    $getPartnerBookmarksInput: GetPartnerBookmarksInput!
  ) {
    getPartnerBookmarks(getPartnerBookmarksInput: $getPartnerBookmarksInput) {
      bookmarks {
        ...partnerDocumentFields
      }
    }
  }
  ${PARTNER_DOCUMENT_FRAGMENT}
`;

export enum GetPartnerBookmarksError {
  NOT_CONNECTED_TO_PARTNER = 'NOT_CONNECTED_TO_PARTNER',
  NO_FAMILY_PORTAL = 'NO_FAMILY_PORTAL',
  PARTNER_NOT_FOUND = 'PARTNER_NOT_FOUND',
  UNAUTHORIZED = 'UNAUTHORIZED',
  UNKNOWN_ERROR = 'UNKNOWN_ERROR',
}

export type GetPartnerBookmarksOutput = {
  getPartnerBookmarks: {
    bookmarks: PartnerDocument[];
    errorReason: GetPartnerBookmarksError[];
  };
};

export const GET_PARTNER_CONTENTS_QUERY = gql`
  query GetPartnerContents($getPartnerContentsInput: GetPartnerContentsInput!) {
    getPartnerContents(getPartnerContentsInput: $getPartnerContentsInput) {
      contents {
        ...partnerContentFields
      }
    }
  }
  ${PARTNER_CONTENT_FRAGMENT}
`;

export enum GetPartnerContentsError {
  NOT_CONNECTED_TO_PARTNER = 'NOT_CONNECTED_TO_PARTNER',
  NO_FAMILY_PORTAL = 'NO_FAMILY_PORTAL',
  PARTNER_NOT_FOUND = 'PARTNER_NOT_FOUND',
  UNAUTHORIZED = 'UNAUTHORIZED',
  UNKNOWN_ERROR = 'UNKNOWN_ERROR',
}

export type GetPartnerContentsOutput = {
  getPartnerContents: {
    contents: PartnerContent[];
    errorReason: GetPartnerContentsError[];
  };
};
